import { createApp } from 'vue'
import App from '../storefront/App.vue'

const root = document.getElementById('storefront')
if (root) createApp(App, { initial: JSON.parse(root.dataset.storefront) }).mount(root)

document.addEventListener('submit', (event) => {
  const message = event.target.dataset?.confirm
  if (message && !window.confirm(message)) event.preventDefault()
})
